import React, { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import { useIsVisible } from 'react-is-visible';
import { genKeyRan } from '../../../javascript/utils/utils';
import { FormatSeconds } from '../../../javascript/utils/utils';
import DBHandler from '../../../javascript/index-db/db-handler';
// import SportLoader from '../../../javascript/sport/sport-loader';
import { SPORT_BASE, NAV_CONTROL } from '../../../javascript/services/globalVars';
import { getClockTime } from '../../../javascript/sport/sport-function';
import RemoteImage from '../../remote_img/remote_img';
import style from '../score-sheet-share-style.module.scss';

import { load_SportLoader_from_db } from '../../../javascript/services/globalVars';

const dbHandler = DBHandler();

var SPORT_CONTROL = null;
function StandardScoreSheet(Props) {
   
   const wrapper = useRef();
   const isVisible = useIsVisible(wrapper);
   const [match, setMatch] = useState(() => { });
   const [nameA, setNameA] = useState(() => 'Player A');
   const [nameB, setNameB] = useState(() => 'Player B');
   const [colorA, setColorA] = useState({ color: "var(--player-a-color)" });
   const [colorB, setColorB] = useState({ color: "var(--player-b-color)" });
   const [matchTime, setMatchTime] = useState(0);
   const [courtIMG, setCourtIMG] = useState(() => '');


   // console.log('>> StandardScoreSheet: ', Props)
   // console.log('>> StandardScoreSheet: ', NAV_CONTROL.state.right_menu_open);


   const setValues = async () => {
      try {
         console.log('>>>>>>>>>>>>>>>>>>>>>>>>> STANDARD SCORE SHEET: ', Props);
   
         if (typeof Props.match_id !== 'undefined') {
            // SPORT_CONTROL = new SportLoader(true);
            SPORT_CONTROL = await load_SportLoader_from_db(true);
            await SPORT_CONTROL.loadMatch(Props.match_id);
            await SPORT_CONTROL.loadGameState(Props.match_id);
         } else {
            SPORT_CONTROL = SPORT_BASE;
         }
   
         const { Match_Players } = SPORT_CONTROL.sport_object.get_player_settings();
         setNameA(Match_Players.teams[0].name);
         setNameB(Match_Players.teams[1].name);
         
         const match_clone = JSON.parse(JSON.stringify( SPORT_CONTROL.sport_object.scoring.state.match ));
   
         // >>> Remove all the T logs
         for (let a = 0; a < match_clone.games.length; a++) {
            for (let b = 0; b < match_clone.games[a].logs.length; b++) {
               if (match_clone.games[a].logs[b].action === 'T') {
                   match_clone.games[a].logs.splice(b, 1); // Remove the log entry
                   b--; // Adjust the loop index since an element was removed
               }
            }
         }
         // console.warn('Setting Match --  Match Clone: ', match_clone);

         setMatch(match_clone);
         calTotalMatchTime(match_clone);
         setColorA({ color: SPORT_CONTROL.sport_object.scoring.state.match.players.teams[0].team_color });
         setColorB({ color: SPORT_CONTROL.sport_object.scoring.state.match.players.teams[1].team_color });
   
         // >>> Get Club Image
         const account_result = await dbHandler.load_club();
         if (typeof account_result !== 'undefined' && account_result.club_logo !== '') {
            setCourtIMG(account_result.club_logo);
         }
         
      } catch (error) {
         console.error('ERROR - setValues: ', error);
      }
   }

   const calLogScore = (logs, index, side) => {
      try {
         let points = 1;
         for (let a = 0; a < logs.length; a++) {
            if (a === index && logs[a].action.includes('S')) {
               return null;
            }
            if (logs[a].action.includes('P+') && logs[a].score_side === side) {
               if (a === index) {
                  points += parseInt(logs[a].action.split('P+')[1]) -1;
                  break;
               } else {
                  points += parseInt(logs[a].action.split('P+')[1]);
               }
            } else if (a === index) {
               if (logs[a].action !== 'P' && !logs[a].action.includes('P+') ) { points = null; }
               break
            } else if (logs[a].action === 'P' && logs[a].score_side === side) {
               points++;
            }
         }
         return points;
      } catch (error) {
         console.error('ERROR - calLogScore: ', error);
      }
   }

   const calGameTime = (startTime, endTime) => {
      try {
         let result = '-';
         const sDate = dayjs(startTime);
         const eDate = dayjs(endTime);
         if (eDate.isValid()) {
            const secondDiff = eDate.diff(sDate, 'second', true);
            result = FormatSeconds(secondDiff)
         }
         return result
      } catch (error) {
         console.error('ERROR - calGameTime: ', error);
      }
   }

   const calGameWon = (game) => {
      try {
         let result = '';
         if (SPORT_CONTROL !== null) {
            const won = SPORT_CONTROL.sport_object.scoring.scoring.who_won(game)
            if (won === 1) {
               result = (<span style={colorA}>{nameA}</span>);
            } else if (won === 2) {
               result = (<span style={colorB}>{nameB}</span>);
            }
         }
         return result;
      } catch (error) {
         console.error('ERROR - calGameWon: ', error);
      }
   }

   const calLogContent = (log, side = 0) => {
      try {
         let result = null;
         if (log.content !== '' && log.content !== 'HO') {
            result = log.content;
         } else if (log.content === 'HO') {
            if (log.server_side === side) {
               result = log.server_inner_side === 1 ? 'L' : 'R';   
            } else {
               result = null;
            }
         } else {
            result = log.server_inner_side === 1 ? 'L' : 'R';
         }
         return result;
      } catch (error) {
         console.error('ERROR - calLogContent: ', error);
      }
   }

   const calTotalMatchTime = async (match) => {
      try {
         let totalTimeSeconds = 0;
         if (typeof match !== 'undefined' && match !== null) {
            for (let a = 0; a < match.games.length; a++) {
               const sDate = dayjs(match.games[a].start_time);
               const eDate = dayjs(match.games[a].end_time);
               const secondDiff = eDate.diff(sDate, 'second', true);
               if (match.games.length - 1 === a && isNaN(secondDiff)) {
                  totalTimeSeconds += await getClockTime("game_clock");
               } else {
                  totalTimeSeconds += secondDiff;
               }
            }
         }
         const result = FormatSeconds(totalTimeSeconds);
         setMatchTime(result);
      } catch (error) {
         console.error('ERROR - calTotalMatchTime: ', error);
      }
   }


   // useEffect(() => { calTotalMatchTime(); }, [match])
   // useEffect(() => { setValues(); }, [useIsVisible(wrapper)]);
   useEffect(() => { 
      // console.error('>>> isVisible: ', isVisible);
      if (isVisible === true) {
         setValues();
      } else {
         setMatch(null);
      }

    }, [isVisible]);



   // TODO: Elements need keys
   return (
      <div className={style.matchWrap} ref={wrapper}>
         <div className={style.matchBox}>
            {/* {NAV_CONTROL.state.right_menu_open === true && typeof match !== 'undefined' && match !== null ? match.games.map((game, a) => ( */}
            {typeof match !== 'undefined' && match !== null ? match.games.map((game, a) => (
               <div className={style.gameWrap} key={genKeyRan('game')} >
                  <div className={style.gameHead}>
                     <div style={colorA}>{nameA}</div>
                     <div style={colorB}>{nameB}</div>
                  </div>
                  {game.logs.map((log, i) => (
                     <div className={style.logWrap} key={genKeyRan('log')} >
                        {calLogScore(game.logs, i, 1) !== null ? (
                           <>
                              <div className={style.logL}>
                                 {log.score_side === 1 ? (
                                    <>
                                       <div className={style.logCont}>{calLogContent(log, 1)}</div>
                                       {calLogScore(game.logs, i, 1) !== null ? (<div className={style.logPoint}><span>{calLogScore(game.logs, i, 1)}</span></div>) : <span>&nbsp;&nbsp;&nbsp;</span>}
                                    </>
                                 ) : (log.content === 'HO' ? (<div className={`${style.logCont} ${style.spaceRight}`}>{calLogContent(log, 1)} </div>) : <div className={style.logSpace}></div>)}
                              </div>
                              <div className={style.logR}>
                                 {log.score_side === 2 ? (
                                    <>
                                       {calLogScore(game.logs, i, 2) !== null ? <div className={style.logPoint}><span>{calLogScore(game.logs, i, 2)}</span></div> : <span>&nbsp;&nbsp;&nbsp;</span>}
                                       <div className={style.logCont}>{calLogContent(log, 2)}</div>
                                    </>
                                 ) : (log.content === 'HO' ? (<div className={`${style.logCont} ${style.spaceLeft}`}> {calLogContent(log, 2)}</div>) : <div className={style.logSpace}></div>)}
                              </div>
                           </>
                        ) : (
                           <>
                           {calLogContent(log) === null ? '' : (
                              <div className={style.logC}>
                              <span>{calLogContent(log)}</span>
                           </div>
                           )}
                           </>
                        )}
                     </div>
                  ))}
                  {game.state === 'complete' ? (<div className={style.gameFoot}>
                     <span>Won By: {calGameWon(game)}</span>
                     <span>Game Time: {calGameTime(game.start_time, game.end_time)}</span>
                     <RemoteImage src={courtIMG} />
                  </div>) : ('')}
               </div>
            )) : ''}
         </div>
         <div className={style.matchTime}><b>Match Time:</b> {matchTime}</div>
      </div>
   );
}

export default StandardScoreSheet; 